/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_oauth_complete_subtitle_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please try again.`)
};

const zh_hans1_oauth_complete_subtitle_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请重试。`)
};

const zh_hant1_oauth_complete_subtitle_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如果問題持續發生，請重新登入或聯絡伺服器管理員。`)
};

const fr_oauth_complete_subtitle_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez réessayer.`)
};

const de_oauth_complete_subtitle_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte versuche es erneut.`)
};

const ja_oauth_complete_subtitle_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`もう一度お試しください。`)
};

const ko_oauth_complete_subtitle_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`문제가 계속되면 다시 로그인하거나 서버 관리자에게 문의하세요.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const oauth_complete_subtitle_error = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.oauth_complete_subtitle_error(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("oauth_complete_subtitle_error", locale)
	if (locale === "en") return en_oauth_complete_subtitle_error(inputs)
	if (locale === "zh-Hans") return zh_hans1_oauth_complete_subtitle_error(inputs)
	if (locale === "zh-Hant") return zh_hant1_oauth_complete_subtitle_error(inputs)
	if (locale === "fr") return fr_oauth_complete_subtitle_error(inputs)
	if (locale === "de") return de_oauth_complete_subtitle_error(inputs)
	if (locale === "ja") return ja_oauth_complete_subtitle_error(inputs)
	return ko_oauth_complete_subtitle_error(inputs)
};